import { PERFORMANCE_STATUS } from 'modules/campaigns/config';
import { CHANNEL_TYPE } from 'modules/campaigns/config/creativeConsts';
import EnumValueCellRenderer from './EnumValueCellRenderer';

export const ChannelTypeCellRenderer = props => {
    const { msgIdPrefix, value, emptyValue, ...rest } = props;

    const channelTypeValue =
        value === PERFORMANCE_STATUS.HTML_CARD ? CHANNEL_TYPE.SPONSORED_DISPLAY : CHANNEL_TYPE.SPONSORED_REGULAR;

    return (
        <EnumValueCellRenderer value={channelTypeValue} msgIdPrefix={msgIdPrefix} emptyValue={emptyValue} {...rest} />
    );
};
